/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleUserManagementState.js'
//import mutations from './moduleUserManagementMutations.js'
import actions from './moduleUserManagementActions.js'
//import getters from './moduleUserManagementGetters.js'
import { getField, updateField } from 'vuex-map-fields';
import _ from 'lodash';
export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations: {
    SET_DEPARTMENT (state, department) {
      state.department = department
    },
    SET_COMPANY (state, company) {
      state.company = company
    },
    SET_USERS (state, users) {
      state.users = users
    },
    SET_USER (state, user) {
      state.user = user
    },
    REMOVE_RECORD (state, itemId) {
      const userIndex = state.users.findIndex((u) => u.id === itemId)
      state.users.splice(userIndex, 1)
    },
    RESET_USER (state) {
      state.user = _.cloneDeep(state.userdefault);
    },
    SET_USEROPTION(state, data){
      state.userOption = data;
    },
    SET_USEROPTION_TRUEWALLET(state,data){
      state.userOptionTrueWallet = data;
    },
    SET_SELECTED (state,user){
      state.user_select = user;
    },
    SET_SELECTED2 (state,user){
      state.user_select2 = user;
    },
    SET_TOTAL (state, total){
      state.total = total
    },
    SET_TOTAL_BONUS (state, total){
      state.totalBonus = total
    },
    SET_DEPOSIT_TOTAL (state, total){
      state.depositTotal = total
    },
    SET_WITHDRAW_TOTAL (state, total){
      state.withdrawTotal = total
    },
    SET_HISTORY (state, history){
      state.history = history
    },
    SET_POPUP (state,popup){
      state.popup = popup;
    },
    SET_POPUP2 (state,popup2){
      state.popup2 = popup2;
    },
    SET_EMPLOYEE (state,employee){
      state.employee = employee;
    },
    SET_EMPLOYEE1 (state,employee){
      state.master = employee;
    },
    SET_SITES (state,data){
      state.sites = data;
    },
    SET_LOGS (state,data){
      state.logs = data;
    },
    SET_BANNERS (state,data){
      state.banners = data;
    },
    SET_BANNERSELECTED (state,data){
      state.banner_select = data;
    },
    SET_CREDIT(state,data){
      state.usercredit = data;
    },
    SET_OLD_CREDIT(state,data){
      state.useroldcredit = data;
    },
    SET_POPUPCREDIT(state,data){
      state.popupcredit = data;
    },
    SET_USERSBANK(state,data){
      state.usersbank = data;
    },
    updateField,
  },
  actions,
  getters: {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
    company: (state) => state.company,
    department: (state) => state.department,
  },
}

